(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["password-main"]) return;
  try {
    
  (() => {
    const root = document.querySelector('.password-editorial');
    if (!root) return;

    const trigger = root.querySelector('.password-editorial__password-trigger');
    const modal = root.querySelector('.password-editorial__modal');
    const closeButton = root.querySelector('.password-editorial__modal-close');
    const backdrop = root.querySelector('.password-editorial__modal-backdrop');
    const passwordInput = root.querySelector('#StorefrontPassword');

    const openModal = () => {
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('password-modal-open');
      window.setTimeout(() => passwordInput?.focus(), 0);
    };

    const closeModal = () => {
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('password-modal-open');
      trigger?.focus();
    };

    trigger?.addEventListener('click', openModal);
    closeButton?.addEventListener('click', closeModal);
    backdrop?.addEventListener('click', closeModal);
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !modal.hidden) closeModal();
    });

    if (root.querySelector('.password-editorial__password-form .errors')) openModal();
  })();

  } catch(e) { console.error(e); }
})();
})();
